import { createContext } from 'react';
/**
 * Create the React Context
 */

export var DndContext = createContext({
  dragDropManager: undefined
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dnd/dist/esm/core/DndContext.js
// module id = 825
// module chunks = 0